import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query'

export function useInvalidateMutation<TData = unknown, TVariables = void, TContext = unknown>(
  mutationFn: (vars: TVariables) => Promise<TData>,
  invalidateKeys: Array<string | readonly unknown[]>,
  options?: UseMutationOptions<TData, unknown, TVariables, TContext>,
) {
  const queryClient = useQueryClient()

  return useMutation<TData, unknown, TVariables, TContext>({
    mutationFn,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateKeys.forEach(key => {
        queryClient.invalidateQueries({ queryKey: Array.isArray(key) ? key : [key] })
      })
      options?.onSuccess?.(data, variables, context)
    },
  })
}
